<template>
    <transition name="slide">
        <div class="slide-item" :style="'background-image:url('+item_data.img +');'">
            <div class="slide-body">
                <p class="slider__link">VINGURUS LATEST POSTS</p>
                <h3 class="slider__h3">
                    <a class="slider__link-title stretched-link" :href="'/'+ lang +'/blog/vingurus-latest-posts/' + item_data.link">
                        {{item_data.blog_content.title}}
                    </a>
                </h3>
                <div class="slider__author">
                    {{item_data.blog_author.name}} {{item_data.blog_author.surname}}<br>
                    {{item_data.created_at}}
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: "Carousel-slide",
    props: {
        item_data: {
            type: Object,
            default: () => {}
        },
        lang: {
            type: String,
            default: () => {}
        }
    }
}
</script>

<style lang="css">
.slide-item {background-repeat: no-repeat;position: absolute;left: 0;right: 0;top: 0;bottom: 0;background-size: contain;}
.slide-body{position:absolute;padding: 40px 25px; bottom: 0; left: 0; background: #ffffff; max-width: 43%;}
.slider__h3{margin: 12px 0 0 0;}
.slider__link{font-size: 14px; text-decoration: none; font-weight: 700; color: #90a0af;}
.slider__link-title{color: #172842; text-decoration: none; font-weight: 800; font-size: calc(14px + 16 * (100vw / 1280));}
.slider__link-title:hover{color: #E2687E;}
.slider__author{color: #90a0af; font-size: 14px; font-weight: 700; text-transform: uppercase; line-height: 15px; margin-top: 12px;}
</style>
